import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatOptionModule, provideNativeDateAdapter } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatInputModule } from '@angular/material/input';
import { CUSTOMERS } from '../../constants/customers.const';

@Component({
    selector: 'app-analytics-filter',
    standalone: true,
    imports: [
        MatFormFieldModule,
        MatDatepickerModule,
        FormsModule,
        ReactiveFormsModule,
        MatButtonModule,
        MatOptionModule,
        MatSelectModule,
        MatExpansionModule,
        MatInputModule
    ],
    providers: [provideNativeDateAdapter()],
    templateUrl: './analytics-filter.component.html',
    styleUrl: './analytics-filter.component.scss',
})
export class AnalyticsFilterComponent implements OnInit {
    @Output() filterEmit = new EventEmitter<FormGroup>();

    customers = CUSTOMERS;

    filterForm = this._getDefaultForm();

    ngOnInit() {
        if (localStorage.getItem('customersFilter')) {
            this.filterForm.get('customers')?.setValue(JSON.parse(localStorage.getItem('customersFilter')!));
        }
        if (localStorage.getItem('startDateFilter')) {
            this.filterForm.get('startDate')?.setValue(new Date(localStorage.getItem('startDateFilter')!));
        }
        if (localStorage.getItem('endDateFilter')) {
            this.filterForm.get('endDate')?.setValue(new Date(localStorage.getItem('endDateFilter')!));
        }

    }

    onApply() {
        if (this.filterForm.value.customers?.length) {
            localStorage.setItem('customersFilter', JSON.stringify(this.filterForm.value.customers))
        }
        if (this.filterForm.value.startDate) {
            const startDate = new Date(this.filterForm.value.startDate);
            startDate.setHours(0, 0, 0, 0); 
            this.filterForm.patchValue({ startDate: startDate });
            localStorage.setItem('startDateFilter', startDate.toISOString());
            localStorage.setItem('startDateFilter', this.filterForm.value.startDate!.toISOString())
        }
        if (this.filterForm.value.endDate) {
            const endDate = new Date(this.filterForm.value.endDate);
            endDate.setHours(23, 59, 0, 0); 
            this.filterForm.patchValue({ endDate: endDate });
            localStorage.setItem('endDateFilter', endDate.toISOString());
        }

        this.filterEmit.emit(this.filterForm);
    }

    onReset() {
        localStorage.removeItem('customersFilter');
        localStorage.removeItem('startDateFilter');
        localStorage.removeItem('endDateFilter');
        this.filterForm = this._getDefaultForm();
    }

    _getDefaultForm() {
        const today: Date = new Date();
        let prevDate: Date = new Date();
        prevDate.setDate(today.getDate() - 30);
        return new FormGroup({
            customers: new FormControl<string[]>([]),
            startDate: new FormControl<Date>(prevDate),
            endDate: new FormControl<Date>(today),
            bugIds: new FormControl<string>(''),
            useCases: new FormControl<string>(''),
            issueGroups: new FormControl<string>(''),
            carts: new FormControl<string>(''),
        });

    }
}
